import axios from 'axios';
import { REACT_APP_API } from '../../config';

export async function updateParticipantStates(userId, groups) {
    try {
        const data = await axios.put(`${REACT_APP_API}/groups/participant/${userId}`, { groups })
        return data?.data
    } catch (error) {
        // Si el error tiene una respuesta del servidor, preservar el mensaje
        if (error?.response?.data?.error) {
            const serverError = new Error(error.response.data.error)
            serverError.response = error.response
            throw serverError
        }
        throw error
    }
}
